export enum modules {
    dashboard = "dashboard",
    interactions = "interactions",
    business = "business",
    collaboration = "collaboration",
    organization = "organization",
    features = 'features',
    access = 'Access',
    approvals ='approvals'
}

export enum subModules {
    saas = "saas",
    sales = "sales",
    analytical = "analytical",
    clients = "clients",
    contacts = "contacts",
    quotes = "quotes",
    invoices = "invoices",
    jobs = "jobs",
    timesheet = "timesheet",
    settings = "settings",
    number_sequences = "number sequences",
    client_types = "client types",
    Staffs = "staffs",
    tasks = "tasks",
    costs = "costs",
    expenses = "expense",
    notes = "notes",
    custom_rates = "custom-rates",
    teams = 'teams',
    roles = 'roles',
    custom_fields = 'custom fields',
    email_templates = 'email templates',
    custom_templates = 'custom templates',
    invoice_templates = 'invoice templates',
    client = 'client',
    staff = 'staff',
    payments = 'Payments',
    adjustments = 'Adjustments',
    billing_history = 'billing history',
    quote_states = 'quote states',
    job_setup = 'job setup',
    staffs = 'staffs'
}

export enum permissionTypes {
    no_access = 1,
    view_only_access = 2,
    create_edit_access = 3,
    full_access = 4,
    enabled = 5,
    disabled = 6
}